export class LoginModel {
    public userName: string;
    public password: string;
}



// WEBPACK FOOTER //
// ./src/models/account/login.model.ts